import React, { useState } from 'react';
import './BoxBuilding.css';

function BoxBuilding() {
    const [boxes, setBoxes] = useState([]);
    const [isDragging, setIsDragging] = useState(false);
    const [currentBox, setCurrentBox] = useState(null);

    const addBox = () => {
        const newBox = {
            id: Math.random(),
            top: Math.random() * 500,
            left: Math.random() * 500
        };
        setBoxes([...boxes, newBox]);
    };

    const clearBoxes = () => {
        setBoxes([]);
    };

    const startDrag = (index) => {
        setIsDragging(true);
        setCurrentBox(index);
    };

    const onDrag = (e) => {
        if (!isDragging) return;
        const newBoxes = [...boxes];
        newBoxes[currentBox].top = e.clientY - 25;
        newBoxes[currentBox].left = e.clientX - 25;
        setBoxes(newBoxes);
    };

    const endDrag = () => {
        setIsDragging(false);
        setCurrentBox(null);
    };

    return (
        <div className="App" onMouseMove={onDrag} onMouseUp={endDrag}  
        onTouchMove={onDrag}
        onTouchUp={endDrag} >
            <h1>Play, Move/drag and build with boxes</h1>
            <div className="controls">
                <button onClick={addBox}>New Box</button>
                <button onClick={clearBoxes}>Clear</button>
            </div>
            <div className="game-area">
                {boxes.map((box, index) => (
                    <div
                        key={box.id}
                        className="box"
                        style={{ top: box.top, left: box.left }}
                        onMouseDown={() => startDrag(index)}
                    ></div>
                ))}
            </div>
        </div>
    );
}

export default BoxBuilding;
